import React, {useState} from 'react';
 
import { Form, Button, Row, Col, ListGroup, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAlignLeft,faXmark, faFileExce } from "@fortawesome/free-solid-svg-icons"; 
import ImageUploading from 'react-images-uploading';
 
 
 
import Rightbar from './Rightbar';
import { Link } from 'react-router-dom';
  
export default function CatalogueImage(){ 
    const [date, setDate] = useState(new Date());
    const [images, setImages] = React.useState([]);
      const maxNumber = 69;
    
      const onChange = (imageList, addUpdateIndex) => {
        // data for submit
        console.log(imageList, addUpdateIndex);
        setImages(imageList);
      };
const [sidebar, setsidebar] = useState(false);
const [mainbar, setmainbar] = useState(false);
const toggle = () => {
    setsidebar(!sidebar);
    setmainbar(!mainbar);
}
return(
  <>
<section className="sec-container" >
   <div className='container'>
      <div className='portalevent'>
         <div className='row'>
            <div className={`col-md-3 portal-sidebar leftbar-close ${sidebar ? 'close' : ''}`}>
                  <div >
                  <Rightbar/>
                  </div>
               </div>
               <div className={`col-md-9 rightbar-open ${mainbar ? 'open' : ''}`}>
                  <div className='rightbar '>
                  <Button variant="outline-info" onClick={toggle}>
                    <FontAwesomeIcon icon={faAlignLeft} />
                  </Button>
                  <h1>BOOTH DESIGN</h1>
                            <h5>We are in the process of assigning your booth location.</h5>
                            <p>
                                You <i>will receive an email notification when your booth is assigned. You will then be able to visit this page</i>
                                and download a PDF booth layout form for your location.
                            </p>
                            <p>
                                Your booth layout form will need to be edited with your layout / design and uploaded into our system.
                            </p>
                            <p>
                                You will also be able to order additional items for your booth on this page at that time.
                            </p>
                            <hr />
                            <div className='boothdesign'>
                            <h4 >Additional Items</h4>
                            <p>
                                Please place your orders for any additional items below. If additional walls, lights, or an outlet is ordered. 
                                Please be sure to indicate where these items should be placed on your Booth Layout Form. Note: All additional items must be paid for in full before
                                the order will be completed. There will be a surcharge added to all items that are ordered after deadline and/or onsite (+50%).
                            </p>
                            <p>
                                <strong>Painting of Panels:</strong> For Customized paint orders, please provide the Benjamin Moore paint type 
                                (e.g. flat or semi-gloss) and color ID number. Booths will be painted for an additional fee prior to 
                                Exhibitor arrival (please order below). Please indicate on your Booth Layout Form which walls are to be painted.
                                Exhibitors who wish to have their booth painted the necessary information by the deadline so that the booth will be ready upon arrival.
                                A fee will be charged for the cost of the paint and the cost of painting and repainting the walls following the Fair.
                                The cost is $75 per 2-foot panel. 
                            </p>
                            <h4 >Booth Customization</h4>
                            <p>
                                If you are ordering extra wall panels, please draw them on your Booth Layout Form exactly where you 
                                would like them to be palced, leaving an opening where desired. please be sure to indicate each wall length 
                                on the drawing (note that all walls come in segments of 2 feet and 4 feet). Additional panels must be located
                                within the borders of the gallery exhibition space only. All build-outs  and electrical orders, such as closests or electrical drops, 
                                should be included and clearly indicated on the Booth Layout Form. You will be contacted if there are any questions or concerns 
                                regarding the submitted proposed layout.
                            </p>
                            <h4 >Outside Walls</h4>
                            <p>
                                Exhibitors with walls adjacent to an asile may use the outside of these walls to exhibit additional work. 
                                Please note that lighting of outside walls is the responsibility of the Exhibitor and that booth package 
                                lights may not be used to light exterior walls. Exhibitors that would like to order lights for their outside walls 
                                should order them below and then draw them into the Booth Layout Form, specifying them as 'Asile' lights. 
                                Interior lights may not be moved to be used as asile lights.
                             </p>
                             <h4 >Storage Options</h4>
                             <p>
                                 Storage for extra artworks may be ordered below (see *Live Art Storage*). Please note that Live Art 
                                 Storage is for loosely packed or unpacked artworks only. No crates, extra packing materials, or personal 
                                 items may be stored in Live Art Storage. Your work must fit into a 4x2 ft space. If you have large works or a 
                                 large amount of work to store, please order multiple Live Art Storage spaces. All empty crates will be stored 
                                 onsite in a separate Empty Crate Storage room. If you are using our preferred shipper (CURATORIAL), Empty Crate Storage is included 
                                 in your quote from them. If you are brining crates any other way - either on your own or through another shipper  - please 
                                 note that a drayage and storage fee of $250 will be added to your final bill. Empty  crates must be empty  - no artwork can be 
                                 stored inside the crates as they will not be accessible during the show.
                             </p>

                             <hr />

                             <h2>BOOTH EXTRAS ORDER FORM</h2>
                             <p> 
                                Basic lighting packages include 17W LED lighting. Please note the basic package includes INTERIOR booth
                                lighting only. Note "on-site" rates ( double - 50% more )will apply after   January 22, 2020.
                             </p>
                             <p><i>Booths come complimentary with the following.</i></p>
                             </div>
                             <br/>
                             <Table>
                                 <tbody>
                                     <tr>
                                         <td><strong>Salon (12x12)</strong></td>
                                         <td>5 lights (17W LED's) + 1 White table and 2 chairs</td>
                                     </tr>
                                     <tr>
                                         <td><strong>Standard (12x16)</strong></td>
                                         <td>7 lights (17W LED's) + 1 White table and 2 chairs</td>
                                     </tr>
                                     <tr>
                                         <td><strong>Medium (12x20)</strong></td>
                                         <td>9 lights (17W LED's) + 1 White table and 2 chairs</td>
                                     </tr>
                                     <tr>
                                         <td><strong>Large (12x24)</strong></td>
                                         <td>11 lights (17W LED's) + 1 White table and 2 chairs</td>
                                     </tr>
                                     <tr>
                                         <td><strong>6ft Table Top</strong></td>
                                         <td>2 lights (17W LED's) + 1 clothed folding table and 2 chairs</td>
                                     </tr>
                                 </tbody>
                             </Table>
                             <br/>
                            <p>
                                You have the option to replace your complimentary LED lights with Halogen Floods
                                (90W) at the additional cost of $20/light. Please be aware that there will be a limited 
                                quantity of Halogen lights available onsite, and all orders are subject to product availaility.
                            </p>
                            <br/>
                            <Table>
                                <tbody>
                                    <tr>
                                        <td >You have (0) items in cart</td>
                                        <td><Link to="/">View Cart & Checkout</Link></td>
                                    </tr>
                                    <tr>
                                        <td >You have (0) items in cart</td>
                                        <td><Link to="/">View Cart & Checkout</Link></td>
                                    </tr>
                                </tbody>
                            </Table>
                            <br/>
                            
                  </div>
            </div>
         </div>
      </div>
   </div>
</section>  

 
</>
)
}
